module.exports = __webpack_public_path__ + "static/tools-050e7e1dbb56db2cbe529fe69ab4a748.svg";